exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".main___10_y5 {\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.item___YXvqk {\n    width: 33.3%;\n    height: 115px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n    -ms-flex-align: center;\n        align-items: center;\n    margin-top: 31px;\n    margin-bottom: 5px;\n\n} \n\n.link___E9LDy{\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.video___36K2i{\n  width: 355px;\n  height: 200px;\n}\n\n\n.right___16yqw {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  width: 50px;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n\n.text___20RB0 {\n  font-size: 12px;\n  color: white;\n  font-family: cursive;\n}\n\n.content___2Vfe9{\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}", ""]);

// exports
exports.locals = {
	"main": "main___10_y5",
	"item": "item___YXvqk",
	"link": "link___E9LDy",
	"video": "video___36K2i",
	"right": "right___16yqw",
	"text": "text___20RB0",
	"content": "content___2Vfe9"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/css/Introduce.css
// module id = 599
// module chunks = 2